import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-basic',
  templateUrl: './button-basic.component.html',
  styleUrls: ['./button-basic.component.scss']
})
export class ButtonBasicComponent implements OnInit {

  @Input() bgColor: string = "";
  @Input() textColor: string = "";
  @Input() width: string = "";
  @Input() buttonText: string = "";
  @Output() onClickButtonEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  emitButtonClickEvent(event: Event) {
    this.onClickButtonEvent.emit(event);
  }
}
